import { ApiRegistrationParticipantProgramDetails } from "../../../../shared/types/ApiRegistrationParticipantProgramDetails";

export function getProgramAndEventName(
  programParticipantId: string,
  participantDetails?: ApiRegistrationParticipantProgramDetails
): { eventName: string; programName: string } {
  let eventName = "";
  let programName = "";
  participantDetails?.events?.find(
    event =>
      !!event.programs?.find(program => {
        const obj = program.programParticipants?.find(pp => pp.id === programParticipantId);
        if (obj) {
          programName = program.name;
          eventName = event.name;
          return true;
        }
        return false;
      })
  );
  return { eventName, programName };
}

export function getEventDetailsByEventParticipantId(
  eventParticipantId: string,
  participantDetails?: ApiRegistrationParticipantProgramDetails
) {
  return participantDetails?.events?.find(event => event.eventParticipant?.id === eventParticipantId);
}

export function getProgram(
  programParticipantId: string,
  participantDetails?: ApiRegistrationParticipantProgramDetails
) {
  const events = participantDetails?.events || [];
  for (let event of events) {
    const programs = event.programs || [];
    for (let program of programs) {
      if (program.programParticipants?.find(pp => pp.id === programParticipantId)) return program;
    }
  }
}

export function getProgramByProgramOrganizationId(
  programOrganizationId: string,
  participantDetails?: ApiRegistrationParticipantProgramDetails
) {
  const events = participantDetails?.events || [];
  for (let event of events) {
    const programs = event.programs || [];
    for (let program of programs) {
      if (program.programOrganizationId === programOrganizationId) return program;
    }
  }
}

export function getEventByProgramOrganizationId(
  programOrganizationId: string,
  participantDetails?: ApiRegistrationParticipantProgramDetails
) {
  const events = participantDetails?.events || [];
  return events.find(e => {
    return Boolean(e.programs?.find(p => p.programOrganizationId === programOrganizationId));
  });
}

export function getEvent(programParticipantId: string, participantDetails?: ApiRegistrationParticipantProgramDetails) {
  const events = participantDetails?.events || [];
  for (let event of events) {
    const programs = event.programs || [];
    for (let program of programs) {
      if (program.programParticipants?.find(pp => pp.id === programParticipantId)) return event;
    }
  }
}
